const unmutedIconName = "fa-volume-high"
const mutedIconName = "fa-volume-xmark"
const isMutedStorageKey = "isMuted"

export const getIsMuted = () => {
  const rawValue = localStorage.getItem(isMutedStorageKey)
  if (rawValue === null) {
    return false
  }

  return Boolean(JSON.parse(rawValue))
}

export const setIsMuted = (newState: boolean) => {
  const volumeIconClasses = getVolumeIcon()?.classList

  if (newState === true) {
    volumeIconClasses?.replace(unmutedIconName, mutedIconName)
  } else {
    volumeIconClasses?.replace(mutedIconName, unmutedIconName)
  }

  const volumeControl = getVolumeControl()
  if (volumeControl === null) {
    return
  }

  volumeControl.disabled = newState
  localStorage.setItem(isMutedStorageKey, String(newState))
}

export const getVolumeIcon = () => {
  return document.getElementById("volume-icon") as HTMLElement | null
}

export const getVolumeControl = () => {
  return document.getElementById("volume-control") as HTMLInputElement | null
}
